import React from 'react'

const TeamEvaluation = () => {
  return (
    <div>TeamEvaluation</div>
  )
}

export default TeamEvaluation